var _rect, _path, _path2, _path3, _path4, _circle, _path5, _path6, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _circle2, _path7, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientLeadGen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 11.5,
    fill: "#F8FBFF",
    stroke: "#EBF1FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.875 55.2538L27.9688 60.41L34.5312 71.4257L37.5781 69.5507L50.4688 74.0038C53.6562 75.3163 57.1094 73.4569 58.4375 72.3632L77.6562 60.41C79.5312 57.9725 77.8125 55.9569 76.7188 55.2538C74.4688 53.1912 69.0625 56.1131 66.6406 57.8319L57.2656 63.4569H54.6875C57.5 61.3944 55.8594 58.8475 54.6875 57.8319L44.8438 54.5506C41.6562 53.0506 38.2031 54.3944 36.875 55.2538Z",
    fill: "#FBD927"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9688 60.5899L31.25 65.7462L48.125 56.1368L44.375 54.4962C41.9375 53.3712 39.4531 54.0274 38.5156 54.4962L27.9688 60.5899Z",
    fill: "#EEC805"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0192 59.0896L56.1598 61.6678C55.5973 62.6053 55.2344 63.3281 54.6875 63.4844L45.3786 60.4959C45.0036 58.9959 46.3161 58.9334 47.0192 59.0896Z",
    fill: "#EEC805"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0846 59.1164C21.1471 59.8664 21.3815 60.8352 21.6159 61.2258L30.5222 76.6947C30.8972 77.4447 32.0847 77.3197 32.6315 77.1635L35.2097 75.7572C36.7097 75.1947 36.4597 73.8041 36.1472 73.1791L27.7097 58.4133C26.7969 56.7145 25.4687 57.2612 24.9219 57.4174C23.9062 58.0424 22.4597 58.9289 22.0846 59.1164Z",
    fill: "#2CB8C1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.6875,
    cy: 60.4901,
    r: 0.9375,
    fill: "#685E68"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 58.1468C27.0312 57.2099 26.0156 57.0526 25.3906 57.2089C28.8281 63.2245 35.75 75.069 35.9375 75.2565C37.0625 74.5065 36.25 73.5389 35.9375 72.9139L27.5 58.1468Z",
    fill: "#B1B1B5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2679 31.8438V25.75C38.5179 25.75 30.8304 25.7969 30.0804 25.9844C21.8304 26.9219 19.9241 33.7188 20.0023 37C20.3773 45.4375 27.1898 48.0156 30.5491 48.25H42.2679V42.3906H31.2523H31.0179C27.6429 42.3906 26.3304 39.7344 26.096 38.4062C25.346 34.2812 28.4398 32.3125 30.0804 31.8438H42.2679Z",
    fill: "#FE646F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38.2812,
    y: 25.75,
    width: 4.21875,
    height: 6.09375,
    fill: "#2CB8C1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38.2812,
    y: 42.1562,
    width: 4.21875,
    height: 6.09375,
    fill: "#2CB8C1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 46.25,
    y: 26.2188,
    width: 12.6562,
    height: 1.875,
    rx: 0.9375,
    fill: "#8AC9FE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 48.125,
    y: 29.9688,
    width: 12.6562,
    height: 1.875,
    rx: 0.9375,
    fill: "#8AC9FE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 46.7188,
    y: 33.25,
    width: 12.6562,
    height: 1.875,
    rx: 0.9375,
    fill: "#8AC9FE"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 47.6562,
    y: 37,
    width: 12.6562,
    height: 1.875,
    rx: 0.9375,
    fill: "#8AC9FE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 46.25,
    y: 40.75,
    width: 12.6562,
    height: 1.875,
    rx: 0.9375,
    fill: "#8AC9FE"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 47.6562,
    y: 44.5,
    width: 12.6562,
    height: 1.875,
    rx: 0.9375,
    fill: "#8AC9FE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.4062,
    cy: 35.5938,
    r: 13.5938,
    fill: "#837683"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6406 37.2344C60.0781 37.6094 57.5 42.5469 57.0312 44.9688C59.8438 48.9531 66.1719 49.1875 66.6406 49.1875C71.8906 48.8125 74.6094 46.375 75.3125 45.2031C74.75 39.2031 69.2969 37.3906 66.6406 37.2344Z",
    fill: "#2CB8C1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.9375,
    cy: 31.6094,
    r: 4.92188,
    fill: "#F6DCCD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientLeadGen);
export default __webpack_public_path__ + "static/media/client_lead_gen.a063e2edc9348f4b0cf7ec1f70f2b19d.svg";
export { ForwardRef as ReactComponent };